import React, { FC, useEffect, useState } from 'react';
import { IQuestion, IQuestionOption } from '@kilornd/api-wrapper';
import styled from 'styled-components';

import Slider from './Slider';
import { Text } from 'components';
import ContinueButton from './QuizContinueButton';
import { useSelector } from 'react-redux';
import { AppState } from 'state/types';

interface SliderQuestionProps {
  question: IQuestion;
  onContinue: ({ value, label }: { value: string; label: string }) => void;
}

const Label = styled(Text)`
  margin: 1.5rem 0rem;
  text-align: center;
`;

const OptionsLabel = styled(Text)`
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Reference = styled(Text)`
  margin-top: 1.5rem;
  margin-bottom: 2rem;
  text-align: left;
  max-width: 19.4375rem;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const SliderQuestion: FC<SliderQuestionProps> = ({ question, onContinue }) => {
  const [value, setValue] = useState<number>(
    question.sliderOptions.defaultValue,
  );
  const { quiz_answers } = useSelector((state: AppState) => state.user);

  const handleContinue = () => {
    onContinue({ value: `${value}`, label: question?.label || '' });
  };

  // Accesses answer based on key ant takes its value as slider max value
  const maxValueQuestionKey = question?.maxValueQuestionKey;
  const maxValue = maxValueQuestionKey
    ? Number(quiz_answers[maxValueQuestionKey])
    : question?.sliderOptions.max;

  useEffect(() => {
    if (maxValue && maxValueQuestionKey) {
      setValue(maxValue);
    }
  }, [maxValue, maxValueQuestionKey]);

  return (
    <Container>
      <Label type="h3">{question?.label}</Label>
      {!!question?.optionsLabel && (
        <OptionsLabel color="dark60" type="bodyS">
          {question.optionsLabel}
        </OptionsLabel>
      )}
      <Slider
        value={value}
        onChange={val => setValue(val)}
        {...question?.sliderOptions}
        max={maxValue}
      />
      {!!question?.reference && (
        <Reference
          color="dark60"
          type="captionM"
          dangerouslySetInnerHTML={{ __html: question.reference }}
        />
      )}
      <ContinueButton title={question?.nextBtnTitle} onClick={handleContinue} />
    </Container>
  );
};

export default SliderQuestion;
